import React from 'react'
import axios from 'axios';
import { useHistory } from 'react-router-dom';


function Topnav() {
    const history = useHistory()

    const LogoutHandler = async () => {
        try {
            await axios.get(`${process.env.REACT_APP_BACKLINK}/api/auth/logout`, { withCredentials: true });

            history.push("/login");
        } catch (error) {
            console.log(error.message)
        }
    }
    return (
        <>
            <nav className="main-header navbar navbar-expand navbar-dark navbar-dark">
                <ul className="navbar-nav">

                    <li className="nav-item">
                        <span className="nav-link" data-widget="pushmenu" role="button"><i className="fas fa-bars"></i></span>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <button onClick={LogoutHandler} className='btn btn-primary'>Logout</button>
                    </li>
                </ul>

            </nav>

        </>
    )
}

export default Topnav
